import { apiGateway } from '../api';

async function buscaEspecialidades(carteirinha) {
    try {
        const response = await apiGateway.get(`agendamento-db/v1/especialidades?carteirinha=${carteirinha}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaRegiao(carteirinha, codigoEspecialidade) {
    try {
        const response = await apiGateway.get(
            `/agendamento-db/v1/regioes?carteirinha=${carteirinha}&codigoEspecialidade=${codigoEspecialidade}`
        );
        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaLocalidade(carteirinha, codigoEspecialidade, codigoRegiao) {
    try {
        const response = await apiGateway.get(
            `/agendamento-db/v1/localidades?carteirinha=${carteirinha}&codigoEspecialidade=${codigoEspecialidade}&codigoRegiao=${codigoRegiao}`
        );
        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaDatasDisponiveis(carteirinha, codigoEspecialidade, codigoLocalidade, periodo) {
    try {
        const response = await apiGateway.get(
            `/agendamento-db/v1/datas?carteirinha=${carteirinha}&codigoEspecialidade=${codigoEspecialidade}&codigoLocalidade=${codigoLocalidade}&periodoDia=${periodo}`
        );
        return response.data;
    } catch (error) {
        return error;
    }
}

async function consultasMedicaPesquisar(carteirinha, codigoEspecialidade, codigoLocalidade, data, periodo) {
    try {
        const response = await apiGateway.get(
            `/agendamento-db/v1/consultas?carteirinha=${carteirinha}&codigoEspecialidade=${codigoEspecialidade}&codigoLocalidade=${codigoLocalidade}&data=${data}&periodoDia=${periodo}`
        );
        return response.data;
    } catch (error) {
        return error;
    }
}

async function cancelarAgendamento(body) {
    try {
        const response = await apiGateway.post('agendamento-db/agp/tasy/cancelar', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function consultasFulturas(body) {
    try {
        const response = await apiGateway.post('agendamento-db/agp/tasy/consultas-futuras/pesquisar', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function gerarProtcoloConsulta(body) {
    try {
        const response = await apiGateway.post('atendimento/protocolo/gerar', body);
        return response.data;
    } catch (error) {
        return [];
    }
}

async function gravaAgendaConsulta(body) {
    try {
        const response = await apiGateway.post('agendamento-db/agp/tasy/consulta-medica/grava-agenda', body);
        return response.data;
    } catch (error) {
        return [];
    }
}

async function gerarPdfAgendaConsulta(body) {
    try {
        const response = await apiGateway.post('agendamento-db/informacoes/busca-dados-pdf-sms', body);
        return response.data;
    } catch (error) {
        return [];
    }
}

export {
    buscaEspecialidades,
    buscaRegiao,
    cancelarAgendamento,
    consultasFulturas,
    consultasMedicaPesquisar,
    gerarProtcoloConsulta,
    gravaAgendaConsulta,
    gerarPdfAgendaConsulta,
    buscaLocalidade,
    buscaDatasDisponiveis,
};
